import React, { useEffect, useState } from "react";
import TheMap from "./components/theMap";
import Weather from "./components/weather";
import Forecast from "./components/forecast";
import { useQuery } from "@tanstack/react-query";
import { getCities, getWeather, logActivity } from "../../api";
import ReactSelect from "react-select";
import Client from "../../utils/client";
import { location_icon } from "../../icons/loaction";
import useGeoLocation from "../../hooks/useGeoLocation";

import { toast } from "react-toastify";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Alerts from "./components/alerts";




function WeatherPage() {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Wheather Page",
  });
  const [data, setData] = useState();
  const [city, setCity] = useState();
  const [forecast, setforecast] = useState();

  const isAuth = !!localStorage.getItem("token"); // or your existing auth logic

  useEffect(() => {
    logActivity("Visit Weather", "Page Visit", null, isAuth);
  }, []);

  const location = useGeoLocation();

  const { data: cities } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCities(),
    initialData: [],
  });

  if (!data && location.loaded) {
    if (location.coordinates) {
      Client.get(
        "/weather/weather/" +
        location.coordinates.long +
        "/" +
        location.coordinates.lat
      ).then((res) => setData(res.data));
      Client.get(
        "/weather/forecast/" +
        location.coordinates.long +
        "/" +
        location.coordinates.lat
      ).then((res) => setforecast(res.data));
    }
    if (location?.error) {
      Client.get("/weather/weather/32.56111432/15.55250644").then((res) =>
        setData(res.data)
      );
      Client.get("/weather/forecast/32.56111432/15.55250644").then((res) =>
        setforecast(res.data)
      );
    }
  }
  // console.log(forecast)
  // console.log(data)
  return (
    <>
      <Helmet>
        ‍<title>الطقس - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="الطقس - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="lg:flex w-full items-center flex-row mt-10 text-right ">

        <Alerts /> {/* Add the Alerts component here */}
      </div>
      <div className="lg:flex w-screen items-center flex-row mt-10  ">
        <div className="lg:w-[40%] mx-6 ">
          <div className=" lg:w-[55%] w-full flex  h-[32rem] flex-col  mx-auto border-secondary  grad rounded-xl  p-8 border drop-shadow-lg  shadow-2xl">
            <div className="  w-full flex flex-row-reverse gap-3">
              <ReactSelect
                onChange={(e) => (
                  Client.get(
                    "/weather/weather/" +
                    e.value.longitude +
                    "/" +
                    e.value.latitude
                  )
                    .then((res) => setData(res.data), setCity(e.value.name))
                    .catch(() =>
                      toast(" لاتتوفر معلومات لهذه المدينه ", { type: "error" })
                    ),
                  Client.get(
                    "/weather/forecast/" +
                    e.value.longitude +
                    "/" +
                    e.value.latitude
                  )
                    .then((res) => setforecast(res.data))
                    .catch(() =>
                      toast(" لاتتوفر معلومات لهذه المدينه ", {
                        type: "error",
                      })
                    )
                )}
                options={cities
                  .filter((e) => (e.longitude !== null, e.latitude !== null))
                  .map((e) => {
                    return { label: e.name, value: e };
                  })}
                hideSelectedOptions={false}
                styles={dropdownStyles}
                closeMenuOnSelect={true}
                isRtl
                placeholder="المدينة"
                className="w-full  "
              />
              <button
                onClick={() => window.location.reload()}
                className="hover:scale-125 ease-in-out duration-200"
              >
                {location_icon}
              </button>
            </div>
            <Weather data={data} city={city} />
          </div>
        </div>
        <div className=" mt-6 lg:mt-0  shadow-xl lg:w-1/2 border-2 border-primary mx-6">
          <TheMap />
        </div>
      </div>
      <div className="w-[90%]  mt-6 lg:mt-16 ">
        {forecast && (
          <div className="text-center my-5 font-medium text-lg">
            توقعات الطقس لمدينة{" "}
            <span className="font-bold text-xl">
              {city ? city : data?.name}
            </span>
          </div>
        )}

        <Forecast data={forecast} city={city} />
      </div>
    </>
  );
}

export default WeatherPage;
const dropdownStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? "green" : "#A7DDB6",
    borderRadius: "15px",
    height: "40px",
    color: "white",
    backgroundColor: "transparent",
    paddingLeft: "8px",
    paddingRight: "8px",
    fontWeight: "500",
    boxShadow: state.isFocused ? "none" : "none",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "white",
    fontWeight: "500",
  }),
  placeholder: (base) => ({
    ...base,
    color: "white",
  }),
  singleValue: (base) => ({
    ...base,
    color: "white",
  }),
  option: (base) => ({
    ...base,
    color: "white",
    ":hover": {
      color: "black",
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "rgba(255,255,255, 0.2)",
    backdropFilter: "blur(6px)",

    color: "black",
  }),
};
